import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-view-single-feedback',
  templateUrl: './view-single-feedback.component.html',
  styleUrls: ['./view-single-feedback.component.css']
})
export class ViewSingleFeedbackComponent implements OnInit {
  feedback: any;

  constructor(
    public dialogRef: MatDialogRef<ViewSingleFeedbackComponent>, 
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.feedback = data.feedback
  }

  ngOnInit(): void {
  }

}
